import { createContext, useContext, Dispatch, SetStateAction } from 'react';
import { Notification, defaultNotificationValue, LoginResponse, CorporateLoginResponse } from '../types';

interface AppContextType {
    notification: Notification;
    setNotification: Dispatch<SetStateAction<Notification>>;
    isDialogOpen: boolean;
    setIsDialogOpen: Dispatch<SetStateAction<boolean>>;
    manageStoreId: number | null;
    setManageStoreId: Dispatch<SetStateAction<number | null>>;
    manageStoreName: string | null;
    setManageStoreName: Dispatch<SetStateAction<string | null>>;
    userDetails: LoginResponse | null;
    setUserDetails: React.Dispatch<React.SetStateAction<LoginResponse | null>>;
    corporationDetails: CorporateLoginResponse;
    setCorporationDetails: Dispatch<SetStateAction<CorporateLoginResponse>>;
    userPermission: string[];
    setUserPermission: Dispatch<SetStateAction<string[]>>;
    redirectTo: string;
    setRedirectTo: Dispatch<SetStateAction<string>>;
}

export const AppContext = createContext<AppContextType>({
    notification: defaultNotificationValue,
    setNotification: () => null,
    isDialogOpen: false,
    setIsDialogOpen: () => null,
    manageStoreId: null,
    setManageStoreId: () => null,
    manageStoreName: null,
    setManageStoreName: () => null,
    userDetails: {
        token: '',
        username: '',
        user_level: 0,
        user_abilities: [],
        token_expires: null,
    },
    setUserDetails: () => null,
    corporationDetails: {
        token: '',
        username: '',
        corporate_name: '',
        user_level: 0,
        user_abilities: [],
        token_expires: null,
    },
    setCorporationDetails: () => null,
    userPermission: [],
    setUserPermission: () => null,
    redirectTo: '',
    setRedirectTo: () => null,
});

export function useAppContext() {
    const context = useContext(AppContext);

    if (!context) {
        throw new Error('useAppContext must be used within a AppProvider');
    }
    return context;
}
